export function getLogedinUser(state) {
    return state.users.currnet;
};

export function getAllUsersSelector(state) {
    return state.users.all;
};